<template>
  <div
    class="teacher-container"
    :class="{
      'speaking-box': isSpeaking,
    }"
  >
    <div
      class="video-box"
      ref="preview_video"
      :id="info.userID + '_video'"
    ></div>
    <div class="close-placeholder" v-if="cameraClose">
      <img :src="processImageUrl(info.avatar, 96)" />
    </div>
    <div class="handle-box" v-if="showHandleBox">
      <div class="audio handle-item" @click="handleChangeAudioStatus">
        <img
          v-if="isMicLoading"
          src="@saas/pages/assets/images/live/loading.png"
          alt=""
          class="loading-icon"
        />
        <img
          v-else-if="micClose"
          src="@saas/pages/assets/images/live/micro-slash.png"
          alt=""
        />
        <img v-else src="@saas/pages/assets/images/live/micro.png" alt="" />
      </div>
      <div
        class="video handle-item"
        @click="handleChangeVideoStatus"
        v-if="roomInfo.mode != 1"
      >
        <img
          v-if="isCameraLoading"
          src="@saas/pages/assets/images/live/loading.png"
          alt=""
          class="loading-icon"
        />
        <img
          v-else-if="cameraClose"
          src="@saas/pages/assets/images/live/video-slash.png"
          alt=""
        />
        <img v-else src="@saas/pages/assets/images/live/video.png" alt="" />
      </div>
      <div
        v-if="isStudent() && !roomInfo.isStudent"
        class="trophy handle-item"
        @click="awardTrophy"
      >
        <img :src="trophyImg" alt="" />
      </div>
      <div class="video handle-item">
        <el-dropdown class="person-dropdown" @command="handleCommand">
          <img src="@saas/pages/assets/images/live/more-point.png" alt="" />
          <el-dropdown-menu slot="dropdown" class="person-dropdown-menu">
            <template v-if="info.isMe">
              <el-dropdown-item command="mirror"> 镜像 </el-dropdown-item>
              <el-dropdown-item command="rename">修改课中昵称</el-dropdown-item>
            </template>
            <template
              v-if="(roomInfo.isTeacher || roomInfo.isAssistant) && !info.isMe"
            >
              <el-dropdown-item command="downstage">下台</el-dropdown-item>
              <el-dropdown-item command="rename">修改课中昵称</el-dropdown-item>
              <el-dropdown-item
                command="whiteboard"
                :disabled="isStudentOffStage"
              >
                白板编辑
              </el-dropdown-item>
              <el-dropdown-item class="remove" command="remove">
                移除学员
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="info-box">
      <div class="role" v-if="info.isAssistant">助教</div>
      <img
        v-if="micClose"
        src="@saas/pages/assets/images/live/mic-close.png"
        alt=""
      />
      <img
        v-else-if="isSpeaking"
        src="@saas/pages/assets/images/live/mic-open.png"
        alt=""
      />
      <img v-else src="@saas/pages/assets/images/live/micro.png" alt="" />
      <div class="name ellipsis">
        {{ info.name || "未知" }}
      </div>
      <span class="me-tag" v-if="info.isMe && !roomInfo.isAssistant"
        >（我）
      </span>
    </div>
    <div class="trophy-count" v-if="isStudent() && info.trophyCount > 0">
      <img :src="trophyCountImg" alt="" />
      <div class="count">
        {{ info.trophyCount > 99 ? "99+" : info.trophyCount || "0" }}
      </div>
    </div>
    <div class="hand-up-box" v-if="info.isHandUp && showRaiseHand">
      <img src="@saas/pages/assets/images/live/hand-color.png" alt="" />
    </div>
    <!-- 移出课堂确认弹窗 -->
    <move-out-class ref="moveOutClass" :studentInfo="moveInfo"></move-out-class>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { setUserRole, updateMicStatus } from "@saas/server-api/src/live-sdk";
import { EventBus } from "@saas/components/src/utils/event-bus";
import MoveOutClass from "../dialog/MoveOutClass.vue";
import screenShare from "../mixins/screen-share";
import handleSelf from "../mixins/handle-self";
import {
  createQueueAsyncFn,
  debounce,
} from "@saas/components/src/utils/debounce-async";
import handleRemote from "../mixins/handle-remote";
import { isStudent } from "../utils/index.js";
import { uploadLiveLog } from "@saas/components/src/utils/log";
// loading图标
const LOADING_IMG = require("@saas/pages/assets/images/live/loading.png");
// 奖杯图片
const TROPHY_IMG = require("@saas/pages/assets/images/live/trophy.png");
import { processImageUrl } from "@saas/components/src";
export default {
  mixins: [screenShare, handleSelf, handleRemote],
  components: {
    MoveOutClass,
  },
  props: {
    studentInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isSpeaking: false,
      info: {},
      speakTimer: null,
      // 状态检查相关
      statusCheckTimer: null,
      lastAudioState: null, // 本地音频状态记录
      lastRemoteAudioMute: null, // 远端音频静音状态记录
      lastVideoState: null,
      statusCheckInterval: 3000, // 3秒检查一次状态
      queueAsyncRemoteAudio: createQueueAsyncFn(),
      queueAsyncRemoteVideo: createQueueAsyncFn(),
      muteRemoteAudioState: null,
      muteRemoteVideoState: null,
      isMicLoading: false,
      isCameraLoading: false,
      isTrophyLoading: false,
    };
  },
  computed: {
    ...mapState("live", [
      "cameraList",
      "liveService",
      "imService",
      "microphoneList",
      "speakerList",
      "layout",
      "roomInfo",
      "userStatus",
      "isMirror",
      "showRaiseHand",
      "videoPermission",
      "audioPermission",
      "currentCameraDevice",
      "remoteScreenShareInfo",
      "isRecordPage",
      "speakerVolume",
    ]),
    trophyImg() {
      if (this.isTrophyLoading) return LOADING_IMG;
      return TROPHY_IMG;
    },
    trophyCountImg() {
      return TROPHY_IMG;
    },
    moveInfo() {
      return {
        user_id: this.info.userID,
        nickname: this.info.name,
      };
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
    micClose() {
      return this.info.audioClose || (!this.audioPermission && this.info.isMe);
    },
    cameraClose() {
      return this.info.videoClose || (!this.videoPermission && this.info.isMe);
    },
    showHandleBox() {
      if (this.info.isMe || this.roomInfo.isTeacher) {
        // 自己可以操作自己或者老师可以操作所有人
        return true;
      } else if (this.roomInfo.isAssistant) {
        // 当前用户是助教，只能操作学生和自己
        return isStudent(this.info.userID);
      } else {
        return false;
      }
    },
    // 判断学生是否处于下台状态（用于禁用白板权限按钮）
    isStudentOffStage() {
      // 仅在大班课场景下生效
      if (this.roomInfo.is_quick_live === 1) {
        // info.is_up_stage: 1-上台, 2-下台
        return this.info.is_up_stage === 2;
      }
      return false;
    },
  },
  watch: {
    studentInfo: {
      handler(val) {
        if (val) {
          this.info = { ...val, userId: val.userID || val.user_id };
        }
      },
      deep: true,
    },
    "studentInfo.videoClose": {
      handler(val) {
        if (this.studentInfo.isMe) {
          this.switchLocalVideoStatus();
        } else {
          // 快直播场景下，下台学生或助教不订阅远端视频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isOpen = !val && this.studentInfo.isReciveStream;
          if (isOpen) {
            this.startRemoteVideo();
          } else {
            this.stopRemoteVideo();
          }
          uploadLiveLog({
            message: `监听--用户${isOpen ? "开启" : "关闭"}远端用户摄像头`,
            level: "info",
            tag: "callback",
            extra: {
              component: "StudentVideo",
              targetUserId: this.studentInfo.userID,
              videoClose: val,
              isOpen,
            },
          });
        }
      },
    },
    "studentInfo.audioClose": {
      handler(val) {
        if (this.studentInfo.isMe) {
          this.switchLocalAudioStatus();
        } else {
          // 快直播场景下，下台学生或助教不订阅远端音频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isMute = !(!val && this.studentInfo.isReciveAudioStream);
          this.muteRemoteAudio(isMute);
          uploadLiveLog({
            message: `监听--用户${isMute ? "关闭" : "开启"}远端用户麦克风`,
            level: "info",
            tag: "callback",
            extra: {
              component: "StudentVideo",
              targetUserId: this.studentInfo.userID,
              isMute,
              audioClose: val,
            },
          });
        }
      },
    },
    // 是否收到远端视频流
    "studentInfo.isReciveStream": {
      handler(val) {
        console.log("isReciveStream___", this.studentInfo.userID);
        if (!this.studentInfo.isMe) {
          // 快直播场景下，下台学生或助教不订阅远端视频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isOpen = val && !this.studentInfo.videoClose;
          if (isOpen) {
            this.startRemoteVideo();
          } else {
            this.stopRemoteVideo();
          }
          uploadLiveLog({
            message: `监听--用户${isOpen ? "开启" : "关闭"}远端用户摄像头推流`,
            level: "info",
            tag: "callback",
            extra: {
              component: "StudentVideo",
              targetUserId: this.studentInfo.userID,
              isOpen,
              isReciveStream: val,
            },
          });
        }
      },
    },
    "studentInfo.isReciveAudioStream": {
      handler(val) {
        console.log("远端音频状态_isReciveAudioStream___", this.studentInfo);
        console.log("远端音频状态_isReciveAudioStream___val", val);
        if (!this.studentInfo.isMe) {
          // 快直播场景下，下台学生或助教不订阅远端音频流
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2 &&
            !this.isRecordPage
          ) {
            return;
          }
          const isMute = !(val && !this.studentInfo.audioClose);
          this.muteRemoteAudio(isMute);
          uploadLiveLog({
            message: `监听--用户${isMute ? "关闭" : "开启"}远端用户麦克风推流`,
            level: "info",
            tag: "callback",
            extra: {
              component: "StudentVideo",
              targetUserId: this.studentInfo.userID,
              isMute,
              isReciveAudioStream: val,
            },
          });
        }
      },
    },
    speakerVolume: {
      handler(val) {
        if (this.liveService) {
          this.liveService.setRemoteAudioVolume({
            userId: this.info.userID,
            volume: val,
          });
        }
      },
    },
    // 监听学生上下台状态变化，触发流切换
    "userStatus.is_up_stage": {
      handler(val, oldVal) {
        // 只有快直播学生才需要处理
        if (
          this.roomInfo.is_quick_live === 1 &&
          (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
          oldVal !== undefined &&
          !this.isRecordPage
        ) {
          uploadLiveLog({
            message: "学生上下台状态变化，触发学生流切换",
            level: "info",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "is_up_stage_change",
              oldVal,
              newVal: val,
              targetStudentUserId: this.studentInfo.userID,
              isMe: this.studentInfo.isMe,
            },
          });

          if (val === 1 && oldVal === 2) {
            // 学生从下台变成上台
            if (this.studentInfo.isMe) {
              // 如果是自己上台，重新设置本地音频状态
              uploadLiveLog({
                message: "学生自己上台，重新设置本地音频状态",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "reset_local_audio_on_upstage",
                  audioClose: this.studentInfo.audioClose,
                },
              });
              this.$nextTick(() => {
                this.switchLocalAudioStatus();
              });
            } else {
              // 如果是远端学生，重新订阅其他学生的 TRTC 流
              uploadLiveLog({
                message: "学生上台，重新订阅其他学生的 TRTC 流",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "resubscribe_student_stream",
                  targetStudentUserId: this.studentInfo.userID,
                  isReciveStream: this.studentInfo.isReciveStream,
                  videoClose: this.studentInfo.videoClose,
                  isReciveAudioStream: this.studentInfo.isReciveAudioStream,
                  audioClose: this.studentInfo.audioClose,
                },
              });
              this.$nextTick(() => {
                // 先更新 info 数据
                this.info = { ...this.studentInfo };

                // 订阅视频流
                if (this.info.isReciveStream && !this.info.videoClose) {
                  uploadLiveLog({
                    message: "学生上台，重新订阅其他学生的视频流",
                    level: "info",
                    tag: "api",
                    extra: {
                      component: "StudentVideo",
                      action: "startRemoteVideo",
                      targetStudentUserId: this.info.userID,
                    },
                  });
                  this.startRemoteVideo();
                }

                // 订阅音频流
                if (this.info.isReciveAudioStream && !this.info.audioClose) {
                  uploadLiveLog({
                    message: "学生上台，重新订阅其他学生的音频流",
                    level: "info",
                    tag: "api",
                    extra: {
                      component: "StudentVideo",
                      action: "muteRemoteAudio",
                      targetStudentUserId: this.info.userID,
                      mute: false,
                    },
                  });
                  this.muteRemoteAudio(false);
                }
              });
            }
          } else if (val === 2 && oldVal === 1) {
            // 学生从上台变成下台
            if (this.studentInfo.isMe) {
              // 如果是自己下台，强制静音本地音频
              uploadLiveLog({
                message: "学生自己下台，强制静音本地音频",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "mute_local_audio_on_downstage",
                },
              });
              this.$nextTick(() => {
                this.switchLocalAudioStatus();
              });
            } else {
              // 如果是远端学生，停止订阅其他学生的 TRTC 流
              uploadLiveLog({
                message: "学生下台，停止订阅其他学生的 TRTC 流",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "unsubscribe_student_stream",
                  targetStudentUserId: this.studentInfo.userID,
                },
              });
              this.stopRemoteVideo();
              this.muteRemoteAudio(true);
            }
          }
        }
      },
    },
  },
  mounted() {
    this.init();
    // this.liveService.enableAudioVolumeEvaluation();
    this.liveService.on("audioVolumnChange", this.onVolumeChange);
    uploadLiveLog({
      message: "StudentVideo组件挂载",
      level: "info",
      tag: "lifecycle",
      extra: {
        component: "StudentVideo",
        userId: this.studentInfo.userID,
        isMe: this.studentInfo.isMe,
        ...this.studentInfo,
      },
    });
  },
  beforeDestroy() {
    if (this.info.isMe) {
      this.stopLocalVideo();
      this.muteLocalAudio(true);
    } else {
      // 快直播下台学生或助教没有订阅远端流，所以也不需要清理
      if (
        !(
          this.roomInfo.is_quick_live === 1 &&
          (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
          this.userStatus.is_up_stage === 2 &&
          !this.isRecordPage
        )
      ) {
        this.stopRemoteVideo();
        this.muteRemoteAudio(true);
      }
    }
    clearTimeout(this.speakTimer);
    this.liveService.off("audioVolumnChange", this.onVolumeChange);
    uploadLiveLog({
      message: "StudentVideo组件销毁",
      level: "info",
      tag: "lifecycle",
      extra: {
        component: "StudentVideo",
        userId: this.info.userID,
        isMe: this.info.isMe,
      },
    });
  },
  methods: {
    ...mapMutations("live", ["setUserStatus", "setShowChangeNickname"]),
    processImageUrl,
    isStudent() {
      return isStudent(this.info.userID);
    },
    init() {
      this.info = { ...this.studentInfo };
      if (this.info.isMe) {
        this.switchLocalAudioStatus();
        this.switchLocalVideoStatus();
        uploadLiveLog({
          message: "用户初始化自己的麦克风和摄像头状态",
          level: "info",
          tag: "userAction",
          extra: {
            component: "StudentVideo",
            targetUserId: this.info.userID,
            isReciveStream: this.info.isReciveStream,
            videoClose: this.info.videoClose,
            audioClose: this.info.audioClose,
            isReciveAudioStream: this.info.isReciveAudioStream,
          },
        });
      } else {
        this.initRemote();
        uploadLiveLog({
          message: "用户初始化远端用户的麦克风和摄像头状态",
          level: "info",
          tag: "userAction",
          extra: {
            component: "StudentVideo",
            targetUserId: this.info.userID,
            isReciveStream: this.info.isReciveStream,
            videoClose: this.info.videoClose,
            audioClose: this.info.audioClose,
            isReciveAudioStream: this.info.isReciveAudioStream,
          },
        });
      }
    },
    initRemote() {
      // 快直播场景下，下台学生或助教不订阅任何人的视频和音频流
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      ) {
        uploadLiveLog({
          message: "快直播下台学生或助教不订阅远端用户的视频和音频流",
          level: "info",
          tag: "api",
          extra: {
            component: "StudentVideo",
            action: "initRemote",
            isStudent: this.roomInfo.isStudent,
            isAssistant: this.roomInfo.isAssistant,
            is_up_stage: this.userStatus.is_up_stage,
            targetUserId: this.info.userID,
          },
        });
        return;
      }

      this.liveService.setRemoteAudioVolume({
        userId: this.info.userID,
        volume: this.speakerVolume,
      });
      // 远端用户
      if (this.info.isReciveStream && !this.info.videoClose) {
        // 远端用户开始推流
        this.startRemoteVideo();
      }
      if (this.info.isReciveAudioStream && !this.info.audioClose) {
        // 远端用户音频推流
        this.muteRemoteAudio(false);
      }
    },
    // 切换音频状态
    switchLocalAudioStatus() {
      if (this.isRecordPage) {
        this.muteLocalAudio(true);
        return;
      }
      // 快直播下台学生或助教强制静音本地音频，避免回声
      if (
        this.roomInfo.is_quick_live === 1 &&
        (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
        this.userStatus.is_up_stage === 2 &&
        !this.isRecordPage
      ) {
        this.muteLocalAudio(true);
        uploadLiveLog({
          message: "快直播下台学生或助教强制静音本地音频",
          level: "info",
          tag: "api",
          extra: {
            component: "StudentVideo",
            action: "switchLocalAudioStatus",
            isStudent: this.roomInfo.isStudent,
            isAssistant: this.roomInfo.isAssistant,
            is_up_stage: this.userStatus.is_up_stage,
          },
        });
        return;
      }
      if (this.info.isMe) {
        if (this.info.audioClose) {
          this.muteLocalAudio(true);
        } else {
          this.muteLocalAudio(false);
        }
      }
    },
    // 切换视频状态
    switchLocalVideoStatus() {
      if (this.info.isMe) {
        if (this.info.videoClose) {
          this.stopLocalVideo();
        } else {
          this.startLocalVideo();
        }
      }
    },
    // 手动切换音频状态
    handleChangeAudioStatus: debounce(
      function () {
        if (this.info.isMe) {
          // 快直播下台学生或助教不能开启麦克风
          if (
            this.roomInfo.is_quick_live === 1 &&
            (this.roomInfo.isStudent || this.roomInfo.isAssistant) &&
            this.userStatus.is_up_stage === 2
          ) {
            this.$darkMessage.warning("请先上台后再开启麦克风");
            uploadLiveLog({
              message: "快直播下台学生或助教尝试开启麦克风被阻止",
              level: "info",
              tag: "userAction",
              extra: {
                component: "StudentVideo",
                action: "handleChangeAudioStatus",
                isStudent: this.roomInfo.isStudent,
                isAssistant: this.roomInfo.isAssistant,
                is_up_stage: this.userStatus.is_up_stage,
              },
            });
            return;
          }
          if (this.isMicLoading) {
            return;
          }
          this.isMicLoading = true;
          const newAudioState = !this.info.audioClose;
          uploadLiveLog({
            message: `用户点击${
              newAudioState ? "开启" : "关闭"
            }自己的麦克风按钮`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "toggleSelfAudio",
              newState: newAudioState,
              userId: this.info.userID,
            },
          });
          this.handleSelfMic(newAudioState)
            .then(() => {
              this.isMicLoading = false;
              uploadLiveLog({
                message: `用户${
                  newAudioState ? "开启" : "关闭"
                }自己的麦克风成功`,
                level: "info",
                tag: "userAction",
                extra: {
                  component: "StudentVideo",
                  action: "toggleSelfAudio",
                  newState: newAudioState,
                  userId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              this.isMicLoading = false;
              uploadLiveLog({
                message: `用户${
                  newAudioState ? "开启" : "关闭"
                }自己的麦克风失败`,
                level: "error",
                tag: "userAction",
                extra: {
                  component: "StudentVideo",
                  action: "toggleSelfAudio",
                  error: error?.message || error,
                },
              });
            });
        } else {
          this.handleRemoteMic();
          uploadLiveLog({
            message: "操作远端用户麦克风",
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "toggleRemoteAudio",
              targetUserId: this.info.userID,
              currentState: this.info.audioClose,
            },
          });
        }
      },
      300,
      true
    ),
    // 手动切换视频状态
    handleChangeVideoStatus: debounce(
      function () {
        if (this.info.isMe) {
          if (this.isCameraLoading) {
            return;
          }
          this.isCameraLoading = true;
          const newVideoState = !this.info.videoClose;
          uploadLiveLog({
            message: `用户${newVideoState ? "开启" : "关闭"}自己的摄像头`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "toggleSelfVideo",
              newState: newVideoState,
              userId: this.info.userID,
            },
          });
          this.handleSelfCamera(newVideoState, this.$refs.preview_video)
            .then(() => {
              this.isCameraLoading = false;
            })
            .catch((error) => {
              this.isCameraLoading = false;
              uploadLiveLog({
                message: `用户${
                  newVideoState ? "开启" : "关闭"
                }自己的摄像头失败`,
                level: "error",
                tag: "userAction",
                extra: {
                  component: "StudentVideo",
                  action: "toggleSelfVideo",
                  error: error?.message || error,
                },
              });
            });
        } else {
          this.handleRemoteCamera();
          uploadLiveLog({
            message: "操作远端用户摄像头",
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "toggleRemoteVideo",
              targetUserId: this.info.userID,
              currentState: this.info.videoClose,
            },
          });
        }
      },
      300,
      true
    ),
    onVolumeChange(res) {
      if (this.info.isMe) {
        if (res.volume > 0 && res.userId === "" && !this.info.audioClose) {
          this.isSpeaking = true;
          this.$emit("speaking", this.info);
          clearTimeout(this.speakTimer);
          this.speakTimer = setTimeout(() => {
            this.isSpeaking = false;
          }, 1000);
        }
      } else {
        if (
          res.userId === this.info.userID &&
          res.volume > 0 &&
          !this.info.audioClose
        ) {
          this.isSpeaking = true;
          this.$emit("speaking", this.info);
          clearTimeout(this.speakTimer);
          this.speakTimer = setTimeout(() => {
            this.isSpeaking = false;
          }, 1000);
        }
      }
    },
    handleCommand(type) {
      if (type === "downstage") {
        // 下台
        this.handleDownstage();
      } else if (type === "whiteboard") {
        // 学生下台状态下不允许开启白板权限
        if (this.isStudentOffStage) {
          this.$darkMessage.warning("学生处于下台状态，无法开启白板权限");
          uploadLiveLog({
            message: "学生处于下台状态，尝试开启白板权限被阻止",
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "setWhiteboard",
              targetUserId: this.info.userID,
              is_up_stage: this.info.is_up_stage,
            },
          });
          return;
        }
        this.setWhiteboard(true);
      } else if (type === "remove") {
        this.handleRemoveStudent();
      } else if (type === "mirror") {
        uploadLiveLog({
          message: `${!this.isMirror ? "开启" : "关闭"}镜像`,
          level: "info",
          tag: "userAction",
          extra: {
            component: "StudentVideo",
            action: "mirror",
            targetMirrorState: !this.isMirror,
          },
        });
        this.liveService.setMirror(!this.isMirror);
      } else if (type === "rename") {
        uploadLiveLog({
          message: "打开修改昵称弹窗",
          level: "info",
          tag: "userAction",
          extra: {
            component: "StudentVideo",
            action: "rename",
            targetUserId: this.info.userID,
            currentNickname: this.info.name,
          },
        });
        this.setShowChangeNickname({
          visible: true,
          info: {
            userId: this.info.userID,
            nickname: this.info.name,
          },
        });
      }
    },
    // 移除学员
    handleRemoveStudent() {
      this.$refs.moveOutClass.open();
      uploadLiveLog({
        message: "点击移除学员按钮",
        level: "info",
        tag: "userAction",
        extra: {
          component: "StudentVideo",
          action: "removeStudent",
          targetUserId: this.info.userID,
        },
      });
    },
    // 下台
    handleDownstage() {
      this.handleRemoteUpDown(this.info.userID, 2)
        .then((res) => {
          uploadLiveLog({
            message: "操作让用户下台",
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "downstage",
              targetUserId: this.info.userID,
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: "操作让用户下台失败",
            level: "error",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "downstage",
              targetUserId: this.info.userID,
              error: error?.message || error,
            },
          });
        });
    },
    // 设置白板编辑
    setWhiteboard(tag) {
      uploadLiveLog({
        message: `${tag ? "开启" : "关闭"}用户白板编辑权限`,
        level: "info",
        tag: "userAction",
        extra: {
          component: "StudentVideo",
          action: "setWhiteboard",
          targetUserId: this.info.userID,
          isWhiteboard: tag,
        },
      });
      this.setUserRole({
        is_whiteboard: tag ? 1 : 2,
      })
        .then((res) => {
          if (res.code === 1) {
            this.imService.sendMGLiveRoomCustomMsg({
              cmdId: 2,
              data: {
                type: "whiteboard",
                data: {
                  userId: this.info.userID,
                  isWhiteboard: tag,
                },
              },
            });
            EventBus.$emit("whiteboard", {
              userId: this.info.userID,
              isWhiteboard: tag,
            });
            uploadLiveLog({
              message: `${tag ? "开启" : "关闭"}用户白板编辑权限成功`,
              level: "info",
              tag: "userAction",
              extra: {
                component: "StudentVideo",
                action: "setWhiteboard",
                targetUserId: this.info.userID,
                isWhiteboard: tag,
              },
            });
          } else {
            this.$darkMessage.error(res.message);
            uploadLiveLog({
              message: `${tag ? "开启" : "关闭"}用户白板编辑权限失败`,
              level: "error",
              tag: "userAction",
              extra: {
                component: "StudentVideo",
                action: "setWhiteboard",
                error: res.message || res,
              },
            });
          }
        })
        .catch((error) => {
          uploadLiveLog({
            message: `${tag ? "开启" : "关闭"}用户白板编辑权限失败`,
            level: "error",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "setWhiteboard",
              error: error?.message || error,
            },
          });
        });
    },
    // 操作远端学生麦克风
    handleRemoteMic() {
      if (this.isMicLoading) {
        return;
      }
      this.isMicLoading = true;
      // 远端用户
      const isMute = !this.info.audioClose;
      this.handleRemoteAudio(this.info.userID, isMute ? 2 : 1)
        .then((res) => {
          this.isMicLoading = false;
          uploadLiveLog({
            message: `${isMute ? "关闭" : "开启"}远端用户麦克风成功`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "handleRemoteMic",
              targetUserId: this.info.userID,
              isMute,
            },
          });
        })
        .catch((error) => {
          this.isMicLoading = false;
          uploadLiveLog({
            message: `${isMute ? "关闭" : "开启"}远端用户麦克风失败`,
            level: "error",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "handleRemoteMic",
              targetUserId: this.info.userID,
              error: error?.message || error,
            },
          });
        });
    },
    // 操作远端学生摄像头
    handleRemoteCamera() {
      if (this.isCameraLoading) {
        return;
      }
      this.isCameraLoading = true;
      // 远端用户
      const isMute = !this.info.videoClose;
      this.handleRemoteVideo(this.info.userID, isMute ? 2 : 1)
        .then((res) => {
          this.isCameraLoading = false;
          uploadLiveLog({
            message: `${isMute ? "关闭" : "开启"}远端用户摄像头成功`,
            level: "info",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "handleRemoteCamera",
              targetUserId: this.info.userID,
              isMute,
            },
          });
        })
        .catch((error) => {
          this.isCameraLoading = false;
          uploadLiveLog({
            message: `${isMute ? "关闭" : "开启"}远端用户摄像头失败`,
            level: "error",
            tag: "userAction",
            extra: {
              component: "StudentVideo",
              action: "handleRemoteCamera",
              targetUserId: this.info.userID,
              error: error?.message || error,
            },
          });
        });
    },
    // 发放奖杯
    awardTrophy() {
      this.isTrophyLoading = true;
      this.handleAwardTrophy(this.info.userID, this.info.name)
        .then(() => {
          this.isTrophyLoading = false;
        })
        .catch((error) => {
          this.isTrophyLoading = false;
          uploadLiveLog({
            message: "发放奖杯失败",
            level: "error",
          });
        });
    },
    // 设置权限
    setUserRole(data) {
      return setUserRole({
        ...data,
        user_id: this.info.userID,
        room_id: this.roomInfo.id,
      });
    },
    // 停止本地摄像头采集
    stopLocalVideo() {
      this.liveService
        .stopLocalPreview()
        .then(() => {
          uploadLiveLog({
            message: "停止本地视频成功",
            level: "info",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "stopLocalVideo",
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: "停止本地视频失败",
            level: "error",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "stopLocalVideo",
              error: error?.message || error,
            },
          });
        });
    },
    // 停止麦克风采集
    stopLocalAudio() {
      this.liveService
        .stopLocalAudio()
        .then(() => {
          uploadLiveLog({
            message: "停止本地音频成功",
            level: "info",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "stopLocalAudio",
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: "停止本地音频失败",
            level: "error",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "stopLocalAudio",
              error: error?.message || error,
            },
          });
        });
    },
    // 开启本地视频推流
    startLocalVideo() {
      if (this.roomInfo.mode === 1) {
        // 极速模式不开启视频
        uploadLiveLog({
          message: "极速模式不开启视频",
          level: "info",
          tag: "api",
          extra: {
            component: "StudentVideo",
            action: "startLocalVideo",
            mode: this.roomInfo.mode,
          },
        });
        return;
      }
      this.liveService.startLocalPreview({
        dom: this.$refs.preview_video,
        publish: true,
      });
      uploadLiveLog({
        message: "开启本地视频",
        level: "info",
        tag: "api",
        extra: {
          component: "StudentVideo",
          action: "startLocalVideo",
        },
      });
    },
    // 暂停/开始本地音频推流 mute true 暂停 false 开启
    muteLocalAudio(mute) {
      this.liveService
        .muteLocalAudio({ mute: mute })
        .then(() => {
          this.lastAudioState = mute;
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}本地音频成功`,
            level: "info",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "muteLocalAudio",
              mute,
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}本地音频失败`,
            level: "error",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "muteLocalAudio",
              mute,
              error: error?.message || error,
            },
          });
        });
    },
    // 开始拉远端视频
    startRemoteVideo() {
      const asyncFn = () => {
        return new Promise((resolve, reject) => {
          if (this.muteRemoteVideoState === false) {
            resolve();
            uploadLiveLog({
              message: "开始拉取远端视频流成功--当前状态相同",
              level: "info",
              tag: "api",
              extra: {
                component: "StudentVideo",
                action: "startRemoteVideo",
                targetUserId: this.info.userID,
              },
            });
            return;
          }
          const params = {
            userID: this.info.userID,
            view: this.$refs.preview_video,
            streamType: 0,
          };
          this.liveService
            .startRemoteView(params)
            .then(() => {
              this.muteRemoteVideoState = false;
              resolve();
              uploadLiveLog({
                message: "开始拉取远端视频流成功",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "startRemoteVideo",
                  targetUserId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              reject(error);
              uploadLiveLog({
                message: "开始拉取远端视频流失败",
                level: "error",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "startRemoteVideo",
                  targetUserId: this.info.userID,
                  error: error?.message || error,
                },
              });
            });
        });
      };
      return this.queueAsyncRemoteVideo(asyncFn);
    },
    // 停止拉远端视频
    stopRemoteVideo() {
      const asyncFn = () => {
        return new Promise((resolve, reject) => {
          if (this.muteRemoteVideoState === true) {
            resolve();
            return;
          }
          this.liveService
            .stopRemoteView({
              userID: this.info.userID,
              streamType: 0,
            })
            .then(() => {
              this.muteRemoteVideoState = true;
              resolve();
              uploadLiveLog({
                message: "停止拉取远端视频流成功",
                level: "info",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "stopRemoteVideo",
                  targetUserId: this.info.userID,
                },
              });
            })
            .catch((error) => {
              reject(error);
              uploadLiveLog({
                message: "停止拉取远端视频流失败",
                level: "error",
                tag: "api",
                extra: {
                  component: "StudentVideo",
                  action: "stopRemoteVideo",
                  targetUserId: this.info.userID,
                  error: error?.message || error,
                },
              });
            });
        });
      };
      return this.queueAsyncRemoteVideo(asyncFn);
    },
    // 暂停/开启远端用户的音频 mute true 静音 false 关闭静音，仅对当前用户有效
    muteRemoteAudio(mute) {
      this.liveService
        .muteRemoteAudio({
          userId: this.info.userID,
          mute: mute,
        })
        .then(() => {
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}远端用户音频成功`,
            level: "info",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              mute,
            },
          });
        })
        .catch((error) => {
          uploadLiveLog({
            message: `${mute ? "静音" : "取消静音"}远端用户音频失败`,
            level: "error",
            tag: "api",
            extra: {
              component: "StudentVideo",
              action: "muteRemoteAudio",
              targetUserId: this.info.userID,
              error: error?.message || error,
            },
          });
        });
      // const asyncFn = () => {
      //   return new Promise((resolve, reject) => {
      //     if (this.muteRemoteAudioState === mute) {
      //       resolve();
      //       uploadLiveLog({
      //         message: `${
      //           mute ? "静音" : "取消静音"
      //         }远端用户音频成功--当前状态相同`,
      //         level: "info",
      //         tag: "api",
      //         extra: {
      //           component: "StudentVideo",
      //           action: "muteRemoteAudio",
      //           targetUserId: this.info.userID,
      //           mute,
      //         },
      //       });
      //       return;
      //     }
      //     this.liveService
      //       .muteRemoteAudio({
      //         userId: this.info.userID,
      //         mute: mute,
      //       })
      //       .then(() => {
      //         this.muteRemoteAudioState = mute;
      //         console.log(`远端音频状态已更新: ${mute ? "静音" : "开启"}`);
      //         resolve();
      //         uploadLiveLog({
      //           message: `${mute ? "静音" : "取消静音"}远端用户音频成功`,
      //           level: "info",
      //           tag: "api",
      //           extra: {
      //             component: "StudentVideo",
      //             action: "muteRemoteAudio",
      //             targetUserId: this.info.userID,
      //             mute,
      //           },
      //         });
      //       })
      //       .catch((error) => {
      //         console.error("远端音频状态切换失败:", error);
      //         reject(error);
      //         uploadLiveLog({
      //           message: `${mute ? "静音" : "取消静音"}远端用户音频失败`,
      //           level: "error",
      //           tag: "api",
      //           extra: {
      //             component: "StudentVideo",
      //             action: "muteRemoteAudio",
      //             targetUserId: this.info.userID,
      //             error: error?.message || error,
      //           },
      //         });
      //       });
      //   });
      // };
      // return this.queueAsyncRemoteAudio(asyncFn);
    },
  },
};
</script>

<style lang="scss" scoped>
.teacher-container {
  width: 156px;
  height: 88px;
  // background: #27272a;
  border-radius: 6px;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  box-sizing: content-box;
  &.speaking-box {
    border-color: #23c343;
  }

  .video-box {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: hidden;
    background: #27272a;
  }

  .close-placeholder {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: #27272a;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      object-fit: cover;
    }
  }

  video {
    width: 156px !important;
    height: 88px !important;
    border-radius: 6px;
  }

  .handle-box {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
    width: 100%;
    height: 24px;
    display: none;
    justify-content: flex-end;
    align-items: center;

    .handle-item {
      width: 24px;
      height: 24px;
      background: rgba(24, 24, 27, 0.6);
      border-radius: 6px 6px 6px 6px;
      border: 1px solid rgba(24, 24, 27, 0.1);
      margin-left: 4px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 18px;
        height: 18px;
      }
    }
  }

  .info-box {
    max-width: 70%;
    padding: 0 4px 0 2px;
    height: 20px;
    background: rgba(24, 24, 27, 0.6);
    border-radius: 6px;
    border: 1px solid rgba(24, 24, 27, 0.1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    left: 2px;
    bottom: 2px;
    z-index: 2;

    .role {
      width: 30px;
      min-width: 30px;
      height: 14px;
      background: #052814;
      border-radius: 4px;
      font-weight: 500;
      font-size: 10px;
      color: #17c964;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    img {
      margin-left: 2px;
      widows: 14px;
      height: 14px;
    }

    .name {
      margin-left: 2px;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
    }

    .me-tag {
      font-size: 12px;
      color: #ffffff;
    }
  }
  .trophy-count {
    position: absolute;
    right: 15px;
    bottom: 5px;
    width: 24px;
    height: 24px;
    z-index: 2;
    img {
      width: 100%;
      height: 100%;
    }
    .count {
      position: absolute;
      right: 0;
      top: 0;
      height: 14px;
      min-width: 14px;
      transform: translate(50%, -20%);
      background: #f9cc45;
      border-radius: 100px;
      border: 1px solid #18181b;
      color: #1d2129;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 1px;
      font-size: 9px;
      font-weight: 600;
      line-height: 14px;
    }
  }

  &:hover {
    .handle-box {
      display: flex;
    }
  }
}

.person-dropdown-menu ::v-deep {
  width: 128px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 0;

  .popper__arrow {
    display: none;
  }

  li {
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    height: 36px;
    border-bottom: 1px solid rgba(229, 231, 235, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: transparent;
      color: #ecedee;
    }

    &.is-disabled {
      color: #71717a;
      cursor: not-allowed;
      opacity: 0.5;

      &:hover {
        color: #71717a;
        background: transparent;
      }
    }
  }

  .remove {
    &:hover {
      color: #f53f3f;
    }
  }
}

.hand-up-box {
  position: absolute;
  left: 3px;
  top: 3px;
  width: 32px;
  height: 32px;
  z-index: 5;

  img {
    width: 32px;
    height: 32px;
  }
}
</style>
